<template>
  <div class="view-upload-container">
    <div class="drip-h4 color-noble-blue-500">
      {{ title }}
    </div>
    <div class="drip-body-small font-weight-400 color-noble-blue-500">
      {{ subtitle }}
    </div>
    <div class="spacing-16"></div>
    <div v-for="(doc, i) in documents" :key="doc.document_id" class="mb-2">
      <div
        class="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between"
      >
        <div class="flex-grow-1 d-flex align-items-center color-noble-blue-500">
          <img
            src="@/assets/images/common/document.svg"
            alt="Document"
            class="mr-2"
          />
          <span class="text-truncate text-md-width">
            {{ doc && doc.name ? doc.name : `Document ${i + 1}` }}
          </span>
        </div>
        <action-button
          variant="text"
          extraClass="d-flex drip-body font-weight-400 removeVerticalPadding h-18 ml-0 ml-md-2"
          :click="() => openLink(doc.url)"
        >
          <svg
            width="14"
            height="17"
            viewBox="0 0 14 17"
            fill="none"
            class="mr-2"
          >
            <path
              d="M14 6H10V0H4V6H0L7 13L14 6ZM6 8V2H8V8H9.17L7 10.17L4.83 8H6ZM0 15H14V17H0V15Z"
              fill="#26B67F"
            />
          </svg>
          {{ $t('bank.view.company.uploads.downloadBtn') }}
        </action-button>
        <!-- <div
          class="d-flex align-items-center drip-body font-weight-400 cursor-pointer color-wealthy-green-500"
          @click="openLink(doc.url)"
        >
          <svg
            width="14"
            height="17"
            viewBox="0 0 14 17"
            fill="none"
            class="mr-2"
          >
            <path
              d="M14 6H10V0H4V6H0L7 13L14 6ZM6 8V2H8V8H9.17L7 10.17L4.83 8H6ZM0 15H14V17H0V15Z"
              fill="#26B67F"
            />
          </svg>
          <span class="color-wealthy-green-500 underline-on-hover">
            {{ $t('bank.view.company.uploads.downloadBtn') }}
          </span>
        </div> -->
      </div>
      <div
        class="spacing-12"
        v-if="documents && documents.length - 1 !== i"
      ></div>
    </div>
  </div>
</template>
<script>
import ActionButton from '@/components/common/ActionButton'

export default {
  components: { ActionButton },
  props: ['title', 'subtitle', 'documents'],
  methods: {
    openLink(url) {
      this.$mpTrack(`Bank details - Open file link to download`)
      window.open(url, '_blank')
    }
  }
}
</script>
<style lang="scss" scoped>
.view-upload-container {
  border: 1px solid $sky-blue-400;
  border-radius: 8px;
  padding: 16px 24px;
  width: 100%;
  .text-md-width {
    max-width: 75%;
    @media screen and (max-width: 1024px) {
      max-width: 360px;
    }
    @media screen and (max-width: 768px) {
      max-width: 300px;
    }
    @media screen and (max-width: 450px) {
      max-width: 100px;
    }
  }
  .h-18 {
    height: 18px;
  }
}
</style>
